export class ProjectActionStatus {
    public id: number;
    public actionStatusName: string;

    constructor(id: number, actionStatusName: string) {
        this.id = id;
        this.actionStatusName = actionStatusName;
    }
}